import { render, staticRenderFns } from "./SettingsAccountNotifications.vue?vue&type=template&id=e57b4670&scoped=true&"
import script from "./SettingsAccountNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingsAccountNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57b4670",
  null
  
)

export default component.exports